import { render } from "./searchBlogs.vue?vue&type=template&id=6f99a5ba"
import script from "./searchBlogs.vue?vue&type=script&lang=js"
export * from "./searchBlogs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__